import { render, staticRenderFns } from "./excludedListings.vue?vue&type=template&id=894b993a"
import script from "./excludedListings.vue?vue&type=script&lang=js"
export * from "./excludedListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports